import { FC } from 'react';
import { DeliveryDates } from '../../../hooks/SubscriptionDetail/useDeliveryDate';
import { Summary } from '../../../hooks/SubscriptionDetail/useSummary';
import { ProductInfo } from '../../../hooks/SubscriptionDetail/useRegisteredProducts';

import { Button } from '../../common/Button';
import { HorizontalRule } from '../../common/HorizontalRule';
import { NavigationWrapper } from '../../common/NavigationWrapper';
import { InformationBox } from '../../common/InformationBox';
import NumberFormat from "react-number-format";
import { SUBSCRIPTION_NAME } from '../../../constants';
import calcPrices from '../../../utils/calcPrices';

export const PausedInformation: FC<{
  summary: Summary,
  dates: DeliveryDates,
  registeredProducts: ProductInfo[],
  loadingAny: boolean,
  pauseCancel: Function
}> = ({ summary, dates, registeredProducts, loadingAny, pauseCancel }) => {

  const {
    nextBillingDate
  } = dates;

  const { totalPrice } = calcPrices(summary);

  const handlePauseCancel = () => pauseCancel();

  return (
    <>
      <InformationBox title={`現在お客様の定期便は一時停止状態となっています。`}>
        <p>
          停止中の{SUBSCRIPTION_NAME}の内容は以下となっています。再開したい場合は、下の再開ボタンを押してください。
        </p>
        <HorizontalRule size="small"/>
        <p>
          合計金額: <NumberFormat
            displayType='text'
            value={ summary ? totalPrice : 0 }
            thousandSeparator={true}
            prefix="￥"
          />(税込・配送料込み)<br/>
          商品合計数量: {registeredProducts.reduce((prev, current) => prev + current.quantity, 0)}点<br/>
          変更締切: { nextBillingDate ? nextBillingDate.subtract(24,'hour').format('YYYY年 M月DD日 (ddd) HH:mm') : '読み込み中' }<br/>
          次回決済日: { nextBillingDate ? nextBillingDate.format('YYYY年 M月DD日 (ddd) HH:mm') : '読み込み中' }
        </p>
      </InformationBox>
      <NavigationWrapper>
        <Button type={'primary'} onClick={handlePauseCancel} disabled={loadingAny}>
          再開する
        </Button>
      </NavigationWrapper>
    </>
  );
}
